<template>
  <div class="page-content">
    <!-- <div class="container"><h1>Login</h1></div> -->
    <section>
      <div class="container">
        <div class="row justify-content-center pt-lg-5 pt-3 form-style">
          <div class="col-lg-7">
            <div
              class="text-center d-flex justify-content-between align-items-center mb-4 pb-3"
            >
              <a @click="$router.push('/home')" class="cursor-pointer">
                <svg
                  width="12"
                  height="16"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.40059 10.7993L1.60059 5.99932L6.40059 1.19932"
                    stroke="#001D21"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <h1 class="font-22 mb-0">Wallet History</h1>
              <div></div>
            </div>

            <div class="card p-4 bg-secondary-light mb-4 rounded-4">
              <div class="d-flex gap-3">
                <div>
                  <img src="static/images/icon-reward.svg" width="65" alt="" />
                </div>
                <div>
                  <h4 class="font-bold text-brand">
                    {{ meData?.workshop?.rewards }}
                  </h4>
                  <p class="text-secondary mb-4">Wallet Balance</p>
                  <button
                    class="btn btn-primary px-5"
                    data-bs-toggle="modal"
                    data-bs-target="#tranferModal"
                  >
                    Transfer to Bank
                  </button>
                </div>
              </div>
            </div>

            <div class="card p-4 mb-3 rounded-4">
              <div class="d-flex justify-content-between align-items-center">
                <p class="mb-0 font-bold font-18">Lifetime Earnings</p>
                <div
                  class="d-flex gap-3 justify-content-end align-items-center"
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.16667 20C4.89052 20 4.66667 19.7761 4.66667 19.5V18.2778C4.66667 18.0016 4.89052 17.7778 5.16667 17.7778H8.83333C9.10948 17.7778 9.33333 17.5539 9.33333 17.2778V14.7377C9.33333 14.5019 9.16788 14.3 8.94046 14.2375C8.14514 14.0189 7.42541 13.6666 6.78125 13.1806C6.11317 12.6765 5.60383 12.0582 5.25321 11.3255C5.17456 11.1611 5.02057 11.0442 4.84062 11.0157C3.511 10.8048 2.38843 10.2116 1.47292 9.23611C0.490972 8.18982 0 6.96296 0 5.55556V4.44444C0 3.83333 0.228472 3.31019 0.685417 2.875C1.14236 2.43982 1.69167 2.22222 2.33333 2.22222H4.16667C4.44281 2.22222 4.66667 1.99836 4.66667 1.72222V0.5C4.66667 0.223858 4.89052 0 5.16667 0H15.8333C16.1095 0 16.3333 0.223858 16.3333 0.5V1.72222C16.3333 1.99836 16.5572 2.22222 16.8333 2.22222H18.6667C19.3083 2.22222 19.8576 2.43982 20.3146 2.875C20.7715 3.31019 21 3.83333 21 4.44444V5.55556C21 6.96296 20.509 8.18982 19.5271 9.23611C18.6116 10.2116 17.489 10.8048 16.1594 11.0157C15.9794 11.0442 15.8254 11.1611 15.7468 11.3255C15.3962 12.0582 14.8868 12.6765 14.2187 13.1806C13.5746 13.6666 12.8549 14.0189 12.0595 14.2375C11.8321 14.3 11.6667 14.5019 11.6667 14.7377V17.2778C11.6667 17.5539 11.8905 17.7778 12.1667 17.7778H15.8333C16.1095 17.7778 16.3333 18.0016 16.3333 18.2778V19.5C16.3333 19.7761 16.1095 20 15.8333 20H5.16667ZM4.02791 8.38094C4.3267 8.54995 4.66667 8.30924 4.66667 7.96597V4.94444C4.66667 4.6683 4.44281 4.44444 4.16667 4.44444H2.83333C2.55719 4.44444 2.33333 4.6683 2.33333 4.94444V5.55556C2.33333 6.25926 2.54722 6.89352 2.975 7.45833C3.26389 7.83977 3.61486 8.14731 4.02791 8.38094ZM10.5 12.2222C11.4722 12.2222 12.2986 11.8981 12.9792 11.25C13.6113 10.648 6.64036 10.4054 5.64462 9.63204C5.52897 9.54221 5.59128 9.38972 5.70273 9.29472L13.2001 2.90403C13.5206 2.63085 14.0146 2.85198 14.0243 3.27297L14.2093 11.2582C14.2148 11.4959 14.0521 11.7046 13.8203 11.7573L9.72245 12.6893C9.49484 12.741 9.26706 13.0178 9.08064 12.8773C8.5674 12.4906 7.49448 10.7487 8.02083 11.25C8.70139 11.8981 9.52778 12.2222 10.5 12.2222ZM16.3333 7.96597C16.3333 8.30924 16.6733 8.54995 16.9721 8.38094C17.3851 8.14731 17.7361 7.83977 18.025 7.45833C18.4528 6.89352 18.6667 6.25926 18.6667 5.55556V4.94444C18.6667 4.6683 18.4428 4.44444 18.1667 4.44444H16.8333C16.5572 4.44444 16.3333 4.6683 16.3333 4.94444V7.96597Z"
                      fill="#F8A61B"
                    />
                    <rect
                      x="7"
                      y="1"
                      width="2"
                      height="11"
                      rx="1"
                      fill="#F7F0E0"
                    />
                  </svg>
                  <p class="mb-0 font-bold font-20">
                    {{ details?.total_earned }}
                  </p>
                </div>
              </div>
            </div>

            <h1 class="font-20 font-bold">Transaction History</h1>
            <ul
              class="nav nav-underline border-bottom justify-content-center mb-4"
              id="myTab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="reward"
                  type="button"
                  :class="{
                    active: currentTab === 'REWARDS',
                  }"
                  @click="onChangeTab('REWARDS')"
                >
                  Transactions
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="bank-transfer"
                  type="button"
                  :class="{
                    active: currentTab === 'BANK_TRANSFER',
                  }"
                  @click="onChangeTab('BANK_TRANSFER')"
                >
                  Bank Transfer
                </button>
              </li>
            </ul>
            <div class="tab-content mb-5" id="myTabContent">
              <div v-if="currentTab === 'REWARDS'">
                <div
                  class="card rounded-4 reward-card"
                  v-for="(item, index) in details?.list"
                  :key="index"
                >
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-lg-8">
                        <p class="mb-0 font-16 font-bold">
                          {{ item?.message }}
                        </p>
                        <p class="text-secondary font-12 mb-0">
                          Order ID: {{ item?.order?.order_no }}
                          <!-- <a href="" class="text-secondary"
                            ><i class="bi bi-copy cursor-pointer"></i
                          ></a> -->
                        </p>
                      </div>
                      <div class="col-lg-4 text-end">
                        <span class="font-bold font-20">{{
                          item?.amount
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3" style="display: flex; justify-content: end">
                <Pagination
                  @page-change="pageChange"
                  @items-per-page-change="itemsPerPageChange"
                  ref="listPagination1"
                />
              </div>
              <ErrorComponent
                @retry="getRewardHistory(currentPage)"
                ref="errorComponent1"
              />
              <div v-if="currentTab === 'BANK_TRANSFER'">
                <div
                  class="card rounded-4 reward-card"
                  v-for="(item, index) in rewardList"
                  :key="index"
                >
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-lg-8">
                        <p class="mb-0 font-16 font-bold">
                          {{ item?.message }}
                        </p>
                        <span>
                          Status:
                          <p
                            class="font-12 mb-0"
                            :class="{
                              'text-danger': item?.trans_status === 'REJECTED',
                              'text-success': item?.trans_status === 'APPROVED',
                              'text-warning': item?.trans_status === 'PENDING',
                              'text-secondary': ![
                                'REJECTED',
                                'APPROVED',
                                'PENDING',
                              ].includes(item?.trans_status),
                            }"
                            style="display: inline; margin: 0"
                          >
                            {{
                              $helperService.getTitleCase(item?.trans_status)
                            }}
                          </p>
                          <!-- <a href="" class="text-secondary"
                            ><i class="bi bi-copy cursor-pointer"></i
                          ></a> -->
                        </span>
                      </div>
                      <div class="col-lg-4 text-end">
                        <span class="font-bold font-20">{{
                          item?.amount
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3" style="display: flex; justify-content: end">
                <Pagination
                  @page-change="pageChange"
                  @items-per-page-change="itemsPerPageChange"
                  ref="listPagination2"
                />
              </div>
              <ErrorComponent
                @retry="getRewardList(currentPage)"
                ref="errorComponent2"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Tranffer to Bank -->
  <div
    class="modal fade"
    id="tranferModal"
    tabindex="-1"
    aria-labelledby="tranferModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <button
          id="close-reward-popup"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          v-on:click="closeModel"
          style="position: absolute; top: 10px; right: 10px; z-index: 9999"
        ></button>
        <Form @submit="sendReward">
          <div class="modal-body">
            <div class="text-center">
              <h4 class="font-22">Transfer to Bank</h4>
              <p>Wallet Balance</p>
              <div class="font-28 text-brand font-bold mb-4">
                ₹{{ meData?.workshop?.rewards }}
              </div>
              <div>
                <Field
                  name="reward-amount"
                  :rules="
                    'required:amount|minRewardAmount:' +
                    minimum_amount_withdrawal
                  "
                  v-slot="{ field }"
                  v-model="amount"
                >
                  <input
                    v-bind="field"
                    type="text"
                    aria-controls="none"
                    class="form-control"
                    v-model="amount"
                    placeholder="Enter amount"
                    onkeypress="return /[0-9]/i.test(event.key)"
                /></Field>
              </div>
            </div>
            <div>
              <ErrorMessage name="reward-amount" class="validation-msg" />
            </div>

            <!-- data-bs-dismiss="modal" -->
            <button
              id="send-reward"
              native-type="submit"
              class="btn btn-primary w-100 mt-2"
            >
              Request Bank Transfer
            </button>
            <p class="font-10 text-danger">
              The minimum withdrawable amount is ₹
              {{ minimum_amount_withdrawal }}
            </p>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.reward-card .card-body {
  border-bottom: 1px solid #ccc;
  &:last-child {
    border-bottom: 0;
  }
}
</style>

<script>
import Pagination from "@/components/Pagination.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent.vue";
import "../Onboarding/onboarding.scss";
export default {
  name: "RewardHistory",
  components: {
    Field,
    Form,
    ErrorMessage,
    ErrorComponent,
    Pagination,
  },
  data() {
    return {
      workshop_id: localStorage.getItem("workshop_id"),
      details: {},
      rewardList: [],
      amount: "",
      currentTab: "REWARDS",
      currentPage: 0,
      offset: -1,
      meData: JSON.parse(localStorage.getItem("userDetail")),
      minimum_amount_withdrawal: "",
    };
  },
  mounted() {
    this.getSettings();
    this.getRewardHistory(this.currentPage);
  },
  methods: {
    onChangeTab(tab) {
      this.currentTab = tab;
      if (this.currentTab === "REWARDS") {
        this.$refs.listPagination2.isShowPagination(false);
        this.getRewardHistory(this.currentPage);
      } else if (this.currentTab === "BANK_TRANSFER") {
        this.$refs.listPagination1.isShowPagination(false);
        this.getRewardList(this.currentPage);
      }
    },
    getRewardHistory(page) {
      if (this.$refs.errorComponent1) {
        this.$refs.errorComponent1.showLoader(true);
      }
      this.$api
        .getAPI({
          _action: "/reward-history",
          _body: { offset: page },
          _hide_loader: true,
        })
        .then((res) => {
          if (res) {
            this.details = res;
            this.offset = res.next_offset;
          }
          if (page >= 0) {
            if (this.$refs.listPagination1) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination1.setTotalCount(res.count);
                this.$refs.listPagination1.setCurrentPage(page + 1);
              } else {
                this.$refs.listPagination1.setTotalCount(0);
              }
            }
          }
          if (!res || res.list.length == 0) {
            this.$refs.errorComponent1.setTitle("No Data Available");
            this.$refs.errorComponent1.isShowMessageValue(false);
          }
          if (this.$refs.errorComponent1) {
            this.$refs.errorComponent1.showLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
          if (this.$refs.errorComponent1) {
            this.$refs.errorComponent1.showLoader(false);
          }
        });
    },
    sendReward() {
      if (this.meData?.workshop?.rewards < this.amount) {
        this.$swal({
          title: "Insufficient Wallet Balance",
          text: `Your available wallet balance is ₹${this.meData?.workshop?.rewards}. You cannot send an amount greater than your rewards balance.`,
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      this.$api
        .postAPI({
          _action: "sent-request",
          _buttonId: "send-reward",
          _body: { amount: this.amount },
        })
        .then((res) => {
          this.closeModel();
          this.getMeCall();
          this.getRewardHistory(this.currentPage);
          this.$toast.open({
            message: res.message,
            type: "success",
            duration: 3000,
            position: "top-right",
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getRewardList(page) {
      if (this.$refs.errorComponent2) {
        this.$refs.errorComponent2.showLoader(true);
      }
      this.$api
        .getAPI({
          _action: "/get-request",
          _body: { offset: page },
          _hide_loader: true,
        })
        .then((res) => {
          if (res) {
            this.rewardList = res.list;
          }
          if (page >= 0) {
            if (this.$refs.listPagination2) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination2.setTotalCount(res.count);
                this.$refs.listPagination2.setCurrentPage(page + 1);
              } else {
                this.$refs.listPagination2.setTotalCount(0);
              }
            }
          }
          if (!res || res.list.length == 0) {
            this.$refs.errorComponent2.setTitle("No Data Available");
            this.$refs.errorComponent2.isShowMessageValue(false);
          }
          if (this.$refs.errorComponent2) {
            this.$refs.errorComponent2.showLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
          if (this.$refs.errorComponent2) {
            this.$refs.errorComponent2.showLoader(false);
          }
        });
    },
    pageChange(offset) {
      this.getRewardHistory(offset - 1);
      this.getRewardList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination1.itemsPerPage;
      this.itemsPerPage = this.$refs.listPagination2.itemsPerPage;
      this.getRewardHistory(this.currentPage);
      this.getRewardList(this.currentPage);
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "me",
        })
        .then((res) => {
          this.$store.commit("setMeCallData", res.result);
          this.meData = res.result;
        })
        .catch(() => {});
    },
    getSettings() {
      this.$api
        .getAPI({
          _action: "setting",
        })
        .then((res) => {
          if (res && res.info) {
            this.minimum_amount_withdrawal = res.info.minimum_amount_withdrawal;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    closeModel() {
      this.amount = "";
      const closebutton = document.getElementById("close-reward-popup");
      closebutton.click();
    },
  },
};
</script>
